import React, { useContext, useEffect, useState } from "react"
import { Col, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { useLocation } from "react-router-dom"
import Navbar from "../../../Components/Navbar/Navbar"
import DatePicker from "react-datepicker"
import Moment from "moment"
import Select from "react-select"
import { Pie } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import * as XLSX from "xlsx"

import NoDataImg from "../../../Assets/Images/no-data-img.png"
import "../ExpensesReport.css"
import downloadIcon from "../../../Assets/Images/download_icon.png"
import { searchExpenseByType } from "./../../../Helpers/apiCalls/ExpensesReports/ExpenseReportApi"
import { getAllExpenseType } from "../../../Helpers/apiCalls/expensetypesApi"
import ChartDataLabels from "chartjs-plugin-datalabels"
import {
  getTodayDate,
  dateFormat,
  numberFormat,
  priorMonth,
  selectDropdownStyle,
  startOfCurrentMonth,
  startOfMonth,
  endOfMonth,
} from "../../../Helpers/Utils/Common"
import Footer from "../../../Components/Footer/Footer"
import { Context } from "../../../Helpers/Utils/Context"
import moment from "moment"

export default function ExpenseByType() {
  let navigate = useNavigate()
  const { setDateFrom, setDateTo, dateFilter } = useContext(Context)
  const location = useLocation()
  const dateToday = getTodayDate()
  const thirtyDaysBefore = (givenDate) => {
    const newDate = new Date(givenDate)
    newDate.setDate(newDate.getDate() - 30)
    newDate.setTime(newDate.getTime() - 1)
    return newDate
  }
  const getMonthFromUrl = () => {
    const searchParams = new URLSearchParams(location.search)
    return searchParams.get("month")
  }
  const defaultStartDate = thirtyDaysBefore(dateToday)
  const month = getMonthFromUrl()
  const startDate = month ? startOfMonth(month) : defaultStartDate
  const endDate = month ? endOfMonth(month) : new Date()

  const [inactive, setInactive] = useState(true)
  const [filterConfig, setFilterConfig] = useState({
    date_from: dateFilter.date_from || startDate,
    date_to: dateFilter.date_to || endDate,
    expense_type_id: "",
    page: 1,
  })
  const [showLoader, setShowLoader] = useState(false)
  const [noData, setNoData] = useState(false)
  // const [expenseType, setExpenseType] = useState([]);
  // const [amount, setAmount] = useState([]);
  // const [background, setBackground] = useState([]);
  // const [border, setBorder] = useState([]);
  // const [totalQuantity, setTotalQuantity] = useState([]);
  const [allExpenseTypes, setAllExpenseTypes] = useState([])
  const [excelData, setExcelData] = useState([])
  const [pieChartData, setPieChartData] = useState({
    labels: [],
    data: [],
  })
  const xlsxHeaders = ["EXPENSE TYPE", "AMOUNT"]

  const pieData = {
    labels: pieChartData.labels,
    datasets: [
      {
        label: "",
        data: pieChartData.data,
        backgroundColor: [
          "rgba(255, 99, 132, 0.2)",
          "rgba(54, 162, 235, 0.2)",
          "rgba(255, 206, 86, 0.2)",
          "rgba(75, 192, 192, 0.2)",
          "rgba(153, 102, 255, 0.2)",
          "rgba(255, 159, 64, 0.2)",
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
        ],
        borderWidth: 1,
      },
    ],
  }

  const pieOptions = {
    plugins: {
      datalabels: {
        display: true,
        align: "start",
        anchor: "end",
        color: "gray",
        borderRadius: 3,
        formatter: (value, context) => {
          const total = context.dataset.data.reduce(
            (accumulator, currentValue) => {
              return Number(accumulator) + Number(currentValue)
            },
            0
          )
          return `${((Number(value) / total) * 100).toFixed(2)}%`
        },
      },
    },
  }

  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
  )

  console.log(filterConfig)

  useEffect(() => {
    async function fetchData() {
      setExcelData([])
      setShowLoader(true)

      const response = await searchExpenseByType(filterConfig)

      if (response.error) {
        setNoData(true)
      } else {
        const pieLabels = []
        const pieValues = []

        response.data.data.map((row) => {
          pieLabels.push(
            `${row.expense_type} (${numberFormat(row.amount_due)})`
          )
          pieValues.push(row.amount_due)
        })

        setPieChartData({ labels: pieLabels, data: pieValues })
        setNoData(false)

        var excel = response.data.data.map((bill) => {
          var info = {}
          info.expense_type = bill.expense_type
          info.expense_amount = bill.expense_amount
          return info
        })

        setExcelData(excel)
      }
      setShowLoader(false)
    }

    fetchData()
  }, [filterConfig])

  function handleExport() {
    const rows = excelData
    const header = ["", ""]
    const meta = [
      ["REPORT TITLE:", "EXPENSE BY TYPE"],
      [
        "EXPENSE TYPE:",
        filterConfig.expense_type_name !== "" &&
        filterConfig.expense_type_name !== undefined
          ? filterConfig.expense_type_name
          : "All types",
      ],
      [
        "DATE FROM:",
        filterConfig.date_from !== "" && filterConfig.date_from !== undefined
          ? dateFormat(filterConfig.date_from)
          : "N/A",
      ],
      [
        "DATE TO:",
        filterConfig.date_to !== "" && filterConfig.date_to !== undefined
          ? dateFormat(filterConfig.date_to)
          : "N/A",
      ],
    ]

    const sheet = XLSX.utils.json_to_sheet([{}], {
      header: header,
    })

    /* generate worksheet and workbook */
    const workbook = XLSX.utils.book_new()
    XLSX.utils.sheet_add_json(sheet, rows, { origin: "A6" })
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet 1")
    XLSX.utils.sheet_add_aoa(sheet, meta, { origin: "A1" })
    XLSX.utils.sheet_add_aoa(sheet, [xlsxHeaders], { origin: "A6" })
    XLSX.writeFile(
      workbook,
      `ExpenseByType (${Moment().format("MMM DD, YYYY")}).xlsx`,
      { compression: true }
    )
  }

  useEffect(() => {
    async function fetchAllExpenseTypes() {
      const response = await getAllExpenseType()
      if (response.data) {
        const res = response.data.map((row) => {
          var info = row
          info.value = row.name
          info.label = row.name
          return info
        })
        setAllExpenseTypes(res)
      }
    }

    fetchAllExpenseTypes()
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"EXPENSES"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={9}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              EXPENSE BY TYPE{" "}
            </h1>
          </Col>
          <Col lg={3} className="mt-2 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={() =>
                  navigate("/expenses", {
                    state: {
                      dateFrom: Moment(filterConfig.date_from).format(
                        "MM-DD-YYYY"
                      ),
                      dateTo: Moment(filterConfig.date_to).format("MM-DD-YYYY"),
                    },
                  })
                }
              >
                Breakdown
              </button>
            </div>
          </Col>
        </Row>

        <div className="tab-content">
          <div className="mb-3" />
          <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
            Filter By:
          </span>
          <Row className="PO-filters flex flex-row mx-2 my-1">
            <Col xs={12} lg={4} className="mb-2 mb-lg-0">
              <Select
                name="type"
                className="dropsearch-filter"
                classNamePrefix="react-select"
                placeholder="Expense Type..."
                styles={selectDropdownStyle}
                selected={allExpenseTypes.map(
                  (item) => item.label === filterConfig.expense_type
                )}
                options={[{ label: "All", value: "" }, ...allExpenseTypes]}
                onChange={(e) =>
                  setFilterConfig((prev) => {
                    return {
                      ...prev,
                      expense_type: e.value,
                      expense_type_name: e.label,
                    }
                  })
                }
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                value={dateFormat(filterConfig.date_from)}
                name="date_from"
                placeholder={Moment().format("MMMM DD, YYYY")}
                selected={filterConfig.date_from}
                onChange={(date) => {
                  setDateFrom(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_from: date }
                  })
                }}
                fixedHeight
                className="date-filter me-4 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
            <Col xs={6} lg={2}>
              <DatePicker
                value={dateFormat(filterConfig.date_to)}
                name="date_to"
                selected={filterConfig.date_to}
                placeholderText={Moment().format("MMMM DD, YYYY")}
                onChange={(date) => {
                  setDateTo(moment(date).format("YYYY-MM-DD"))
                  setFilterConfig((prev) => {
                    return { ...prev, date_to: date }
                  })
                }}
                fixedHeight
                className="date-filter ps-label-content me-5 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </Col>
          </Row>
          <div className="mb-2" />

          <div className="below d-flex justify-content-center mb-5">
            {!noData ? (
              <Pie
                className="pie-chart"
                data={pieData}
                options={pieOptions}
                plugins={[ChartDataLabels]}
              />
            ) : (
              <div className="no-data-cont">
                <img
                  src={NoDataImg}
                  alt="no data found"
                  className="no-data-small"
                />
                <span>Uh Oh! No data found.</span>
              </div>
            )}
          </div>
          <div className="mb-2" />
        </div>
        <div className="mb-3" />
        <Row>
          <Col lg={10} className="mt-3 mt-lg-0"></Col>
          <Col lg={2} className="mt-3 mt-lg-0">
            <div className="PO-filters">
              <button
                type="button"
                className="primary-btn"
                onClick={handleExport}
              >
                <span className="me-2">
                  <img width={20} height={20} src={downloadIcon} alt=""></img>
                </span>
                Download
              </button>
            </div>
          </Col>
        </Row>
        <div className="mb-3" />
        <br />
        <br />
      </div>
      <Footer />
    </div>
  )
}
